import {authStoreKey} from '@blesk-frontend/auth';
import {redirect} from '@tanstack/react-router';
import {updateExtensionToken} from '@/libs';
import {RouterGuardOtps} from '@/libs/router';

/**
 *
 * @param context
 * @param location
 */
export const authSignedGuard = ({location}: RouterGuardOtps<{isAdmin?: boolean}>) => {
  const token: string | undefined = JSON.parse(localStorage.getItem(authStoreKey) ?? '{}')?.state
    ?.token;

  if (token && location.href.includes('/auth/signin?redirect=extension')) {
    // todo: добавить обработку ошибок
    updateExtensionToken(token).finally(() => {
      window.close();
    });
    return;
  }

  if (token && !(location.pathname === '/auth/callback' && location.search.isAdmin === true)) {
    throw redirect({
      to: '/',
      search: {
        redirect: location.href,
      },
    });
  }
};
